var map = {
	"./apple-logo.svg": 71970,
	"./authentication-bg.png": 12150,
	"./authentication/authentication-bg.png": 31485,
	"./authentication/email-verification-img.jpg": 16439,
	"./authentication/email02.png": 18795,
	"./authentication/error-404.png": 91240,
	"./authentication/error-500.png": 94157,
	"./authentication/forget-img.png": 41952,
	"./authentication/forgot-02.png": 51925,
	"./authentication/forgot-password-img.jpg": 32138,
	"./authentication/login-bg.png": 85816,
	"./authentication/login-img.jpg": 78264,
	"./authentication/login.jpg": 81026,
	"./authentication/login02.png": 78940,
	"./authentication/register-img.jpg": 69332,
	"./authentication/register02.jpg": 93724,
	"./authentication/reset-password-img.jpg": 9750,
	"./authentication/reset02.png": 53150,
	"./authentication/step-two.png": 34886,
	"./authentication/under-maintenance.png": 36869,
	"./authentication/verify-img.png": 59144,
	"./avatar/New folder/avatar-18.jpg": 26252,
	"./avatar/avatar-1.jpg": 20525,
	"./avatar/avatar-10.jpg": 21953,
	"./avatar/avatar-11.jpg": 32004,
	"./avatar/avatar-12.jpg": 74579,
	"./avatar/avatar-13.jpg": 29814,
	"./avatar/avatar-14.jpg": 52509,
	"./avatar/avatar-14.png": 76749,
	"./avatar/avatar-15.jpg": 84416,
	"./avatar/avatar-15.png": 13508,
	"./avatar/avatar-16.jpg": 74735,
	"./avatar/avatar-16.png": 98783,
	"./avatar/avatar-17.jpg": 98354,
	"./avatar/avatar-18.jpg": 81065,
	"./avatar/avatar-2.jpg": 7618,
	"./avatar/avatar-3.jpg": 20287,
	"./avatar/avatar-4.jpg": 83124,
	"./avatar/avatar-5.jpg": 96849,
	"./avatar/avatar-6.jpg": 39078,
	"./avatar/avatar-7.jpg": 77603,
	"./avatar/avatar-8.jpg": 14104,
	"./avatar/avatar-9.jpg": 58933,
	"./avatar/group-01.png": 44367,
	"./avatar/group-02.png": 21908,
	"./barcode-01.png": 10552,
	"./barcode-02.png": 85043,
	"./barcode-03.jpg": 86510,
	"./barcode/barcode-01.png": 10019,
	"./barcode/barcode-02.png": 48040,
	"./barcode/barcode-03.jpg": 93737,
	"./barcode/barcode1.png": 87630,
	"./barcode/qr-code.png": 91494,
	"./barcode1.png": 3645,
	"./brand/adidas.jpg": 95842,
	"./brand/adidas.png": 27398,
	"./brand/brand-icon-01.png": 46645,
	"./brand/brand-icon-02.png": 79294,
	"./brand/brand-icon-03.png": 81255,
	"./brand/brand-icon-04.png": 6088,
	"./brand/brand-icon-05.png": 20305,
	"./brand/brand-icon-06.png": 90138,
	"./brand/brand-icon-07.png": 91363,
	"./brand/brand-icon-08.png": 33700,
	"./brand/brand-icon-09.png": 73645,
	"./brand/brand-icon-10.png": 13815,
	"./brand/colgate.png": 24847,
	"./brand/samsung.png": 48432,
	"./categories/category-01.png": 30217,
	"./categories/category-02.png": 99250,
	"./categories/category-03.png": 14075,
	"./categories/category-04.png": 50212,
	"./categories/category-05.png": 4109,
	"./categories/category-06.png": 90134,
	"./check-icon.svg": 424,
	"./coming-soon.png": 62501,
	"./customer/avatar.png": 27242,
	"./customer/customer1.jpg": 41580,
	"./customer/customer10.jpg": 41182,
	"./customer/customer2.jpg": 68027,
	"./customer/customer3.jpg": 36542,
	"./customer/customer4.jpg": 81541,
	"./customer/customer5.jpg": 38024,
	"./customer/customer6.jpg": 22775,
	"./customer/customer7.jpg": 58938,
	"./customer/customer8.jpg": 26401,
	"./customer/customer9.jpg": 48356,
	"./customer/no-imagecustomer.png": 2788,
	"./customer/people-customer-07.jpg": 27389,
	"./customer/profile.jpg": 35786,
	"./customer/profile2.jpg": 45786,
	"./customer/profile3.jpg": 14071,
	"./customer/profile4.jpg": 37484,
	"./customer/profile5.jpg": 51625,
	"./download-img.png": 80626,
	"./edit-supplier.jpg": 27879,
	"./email02.png": 24764,
	"./error-404.png": 14679,
	"./error-500.png": 52818,
	"./facebook-logo.svg": 75538,
	"./file-manager/folder-lg.png": 61695,
	"./file-manager/video1-.jpg": 92994,
	"./file-manager/video1.jpg": 33891,
	"./file-manager/video2.jpg": 87828,
	"./file-manager/video3.jpg": 59633,
	"./file-text-icon-01.svg": 8510,
	"./flags/ad.png": 94663,
	"./flags/ae.png": 76350,
	"./flags/af.png": 43701,
	"./flags/ag.png": 74604,
	"./flags/ai.png": 14546,
	"./flags/al.png": 1759,
	"./flags/am.png": 5430,
	"./flags/ao.png": 47108,
	"./flags/ar.png": 91553,
	"./flags/as.png": 6936,
	"./flags/at.png": 98455,
	"./flags/au.png": 39086,
	"./flags/aw.png": 97820,
	"./flags/ax.png": 1419,
	"./flags/az.png": 28473,
	"./flags/ba.png": 17819,
	"./flags/bb.png": 20256,
	"./flags/bd.png": 94486,
	"./flags/be.png": 48287,
	"./flags/bf.png": 63012,
	"./flags/bg.png": 26253,
	"./flags/bh.png": 57018,
	"./flags/bi.png": 63203,
	"./flags/bj.png": 84872,
	"./flags/bl.png": 88702,
	"./flags/bm.png": 64487,
	"./flags/bn.png": 13804,
	"./flags/bo.png": 25429,
	"./flags/bq.png": 43499,
	"./flags/br.png": 78096,
	"./flags/bs.png": 10201,
	"./flags/bt.png": 5222,
	"./flags/bv.png": 67860,
	"./flags/bw.png": 88989,
	"./flags/by.png": 63155,
	"./flags/bz.png": 88664,
	"./flags/ca.png": 20276,
	"./flags/cc.png": 57638,
	"./flags/cd.png": 62617,
	"./flags/cf.png": 12267,
	"./flags/cg.png": 48610,
	"./flags/ch.png": 49477,
	"./flags/ci.png": 15612,
	"./flags/ck.png": 30702,
	"./flags/cl.png": 13793,
	"./flags/cm.png": 41080,
	"./flags/cn.png": 15571,
	"./flags/co.png": 64810,
	"./flags/cr.png": 703,
	"./flags/cu.png": 72672,
	"./flags/cv.png": 70235,
	"./flags/cw.png": 48690,
	"./flags/cx.png": 77845,
	"./flags/cy.png": 66220,
	"./flags/cz.png": 16903,
	"./flags/de.png": 5593,
	"./flags/dj.png": 32558,
	"./flags/dk.png": 32055,
	"./flags/dm.png": 31041,
	"./flags/do.png": 5523,
	"./flags/dz.png": 58366,
	"./flags/ec.png": 72676,
	"./flags/ee.png": 5938,
	"./flags/eg.png": 29920,
	"./flags/er.png": 98653,
	"./flags/es.png": 77524,
	"./flags/et.png": 53163,
	"./flags/fi.png": 26831,
	"./flags/fj.png": 7924,
	"./flags/fk.png": 29053,
	"./flags/fm.png": 53835,
	"./flags/fo.png": 80889,
	"./flags/fr.png": 27020,
	"./flags/ga.png": 73696,
	"./flags/gb.png": 35675,
	"./flags/gd.png": 25709,
	"./flags/ge.png": 71812,
	"./flags/gf.png": 8671,
	"./flags/gg.png": 11734,
	"./flags/gh.png": 89041,
	"./flags/gi.png": 78824,
	"./flags/gl.png": 91701,
	"./flags/gm.png": 55788,
	"./flags/gn.png": 58439,
	"./flags/gp.png": 53177,
	"./flags/gq.png": 46928,
	"./flags/gr.png": 77099,
	"./flags/gs.png": 86594,
	"./flags/gt.png": 48317,
	"./flags/gu.png": 10836,
	"./flags/gw.png": 50758,
	"./flags/gy.png": 57496,
	"./flags/hk.png": 5907,
	"./flags/hn.png": 21038,
	"./flags/hr.png": 39026,
	"./flags/ht.png": 5764,
	"./flags/hu.png": 69005,
	"./flags/id.png": 45535,
	"./flags/ie.png": 67446,
	"./flags/il.png": 30503,
	"./flags/im.png": 42814,
	"./flags/in.png": 28565,
	"./flags/io.png": 62028,
	"./flags/iq.png": 99778,
	"./flags/ir.png": 55865,
	"./flags/is.png": 49616,
	"./flags/it.png": 61839,
	"./flags/je.png": 12727,
	"./flags/jm.png": 65391,
	"./flags/jo.png": 81405,
	"./flags/jp.png": 1018,
	"./flags/ke.png": 75208,
	"./flags/kg.png": 47354,
	"./flags/kh.png": 16589,
	"./flags/ki.png": 53348,
	"./flags/km.png": 10592,
	"./flags/kn.png": 8155,
	"./flags/kp.png": 87397,
	"./flags/kr.png": 58615,
	"./flags/kw.png": 2730,
	"./flags/ky.png": 58196,
	"./flags/kz.png": 80655,
	"./flags/la.png": 82037,
	"./flags/lb.png": 96286,
	"./flags/lc.png": 48775,
	"./flags/li.png": 16045,
	"./flags/lk.png": 99007,
	"./flags/lr.png": 70478,
	"./flags/ls.png": 53623,
	"./flags/lt.png": 47832,
	"./flags/lu.png": 68961,
	"./flags/lv.png": 11530,
	"./flags/ly.png": 38653,
	"./flags/ma.png": 22894,
	"./flags/mc.png": 98460,
	"./flags/md.png": 95859,
	"./flags/me.png": 63946,
	"./flags/mg.png": 248,
	"./flags/mh.png": 75055,
	"./flags/mk.png": 69940,
	"./flags/ml.png": 19851,
	"./flags/mm.png": 29346,
	"./flags/mn.png": 95929,
	"./flags/mo.png": 6032,
	"./flags/mp.png": 1191,
	"./flags/mq.png": 48702,
	"./flags/mr.png": 50805,
	"./flags/ms.png": 98540,
	"./flags/mt.png": 74787,
	"./flags/mu.png": 10682,
	"./flags/mv.png": 31793,
	"./flags/mw.png": 21576,
	"./flags/mx.png": 51423,
	"./flags/my.png": 54486,
	"./flags/mz.png": 68461,
	"./flags/na.png": 14255,
	"./flags/nc.png": 56445,
	"./flags/ne.png": 89675,
	"./flags/nf.png": 2032,
	"./flags/ng.png": 8281,
	"./flags/ni.png": 21943,
	"./flags/nl.png": 79850,
	"./flags/no.png": 10433,
	"./flags/np.png": 19862,
	"./flags/nr.png": 84388,
	"./flags/nu.png": 94331,
	"./flags/nz.png": 14444,
	"./flags/om.png": 98260,
	"./flags/pa.png": 55953,
	"./flags/pe.png": 58613,
	"./flags/pf.png": 72862,
	"./flags/pg.png": 25351,
	"./flags/ph.png": 40608,
	"./flags/pk.png": 2587,
	"./flags/pl.png": 38724,
	"./flags/pm.png": 92621,
	"./flags/pn.png": 78646,
	"./flags/pr.png": 88106,
	"./flags/ps.png": 20019,
	"./flags/pt.png": 22620,
	"./flags/pw.png": 30199,
	"./flags/py.png": 20089,
	"./flags/qa.png": 40522,
	"./flags/re.png": 90831,
	"./flags/ro.png": 23301,
	"./flags/rs.png": 87049,
	"./flags/ru.png": 74527,
	"./flags/rw.png": 3469,
	"./flags/sa.png": 66436,
	"./flags/sb.png": 21087,
	"./flags/sc.png": 24758,
	"./flags/sd.png": 24585,
	"./flags/se.png": 69760,
	"./flags/sg.png": 33874,
	"./flags/sh.png": 63029,
	"./flags/si.png": 93932,
	"./flags/sk.png": 95678,
	"./flags/sl.png": 36689,
	"./flags/sm.png": 38824,
	"./flags/sn.png": 24099,
	"./flags/so.png": 6522,
	"./flags/sr.png": 93743,
	"./flags/ss.png": 54726,
	"./flags/st.png": 47801,
	"./flags/sv.png": 20747,
	"./flags/sx.png": 46565,
	"./flags/sy.png": 17148,
	"./flags/sz.png": 17783,
	"./flags/tc.png": 31775,
	"./flags/td.png": 73120,
	"./flags/tf.png": 79154,
	"./flags/tg.png": 28155,
	"./flags/th.png": 48268,
	"./flags/tj.png": 29054,
	"./flags/tk.png": 16743,
	"./flags/tl.png": 25224,
	"./flags/tm.png": 65169,
	"./flags/tn.png": 56858,
	"./flags/to.png": 78435,
	"./flags/tr.png": 9062,
	"./flags/tt.png": 35856,
	"./flags/tv.png": 86018,
	"./flags/tw.png": 7147,
	"./flags/tz.png": 26542,
	"./flags/ua.png": 61478,
	"./flags/ug.png": 88272,
	"./flags/um.png": 66090,
	"./flags/us.png": 70628,
	"./flags/us1.png": 50631,
	"./flags/uy.png": 81470,
	"./flags/uz.png": 67221,
	"./flags/va.png": 41063,
	"./flags/vc.png": 2005,
	"./flags/ve.png": 23427,
	"./flags/vg.png": 9841,
	"./flags/vi.png": 24863,
	"./flags/vn.png": 96832,
	"./flags/vu.png": 39731,
	"./flags/wf.png": 19311,
	"./flags/ws.png": 25266,
	"./flags/ye.png": 97478,
	"./flags/yt.png": 63839,
	"./flags/za.png": 59107,
	"./flags/zm.png": 12447,
	"./flags/zw.png": 61221,
	"./forget-img.png": 24333,
	"./forrget02.png": 53559,
	"./hand01.svg": 67420,
	"./icon/audio.svg": 61702,
	"./icon/cash.svg": 64697,
	"./icon/credit-card.svg": 34914,
	"./icon/drag-drop.svg": 73172,
	"./icon/emoj-icon-01.svg": 26379,
	"./icon/emoj-icon-02.svg": 87544,
	"./icon/emoj-icon-03.svg": 22409,
	"./icon/emoj-icon-04.svg": 19814,
	"./icon/emoj-icon-05.svg": 7351,
	"./icon/emoji-smile.svg": 94961,
	"./icon/folder.svg": 17460,
	"./icon/half-circle.svg": 24208,
	"./icon/heart.svg": 17324,
	"./icon/image.svg": 96423,
	"./icon/like.svg": 82513,
	"./icon/pdf.svg": 2074,
	"./icon/play-01.svg": 93758,
	"./icon/qr-scan.svg": 23837,
	"./icon/smile-chat.svg": 86623,
	"./icon/trash-bin.svg": 51082,
	"./icon/video.svg": 13617,
	"./icon/xls.svg": 44599,
	"./icon/zip.svg": 75373,
	"./icons/Calculator.svg": 46251,
	"./icons/Macbook.svg": 30371,
	"./icons/Vector.svg": 21194,
	"./icons/add-circle.svg": 94197,
	"./icons/addprofile.svg": 63079,
	"./icons/airplay.svg": 83227,
	"./icons/app-icon-01.svg": 33378,
	"./icons/app-icon-02.svg": 90481,
	"./icons/app-icon-03.svg": 76096,
	"./icons/app-icon-04.svg": 93567,
	"./icons/app-icon-05.svg": 78926,
	"./icons/app-icon-06.svg": 61901,
	"./icons/app-icon-07.svg": 14540,
	"./icons/app-icon-08.svg": 41419,
	"./icons/app-icon-09.svg": 47546,
	"./icons/app-icon-10.svg": 52272,
	"./icons/apple-logo.svg": 89239,
	"./icons/arrow-left.svg": 73792,
	"./icons/audio.svg": 63823,
	"./icons/bar.svg": 89914,
	"./icons/bar1.svg": 16375,
	"./icons/bell.svg": 66876,
	"./icons/calendars.svg": 73272,
	"./icons/cash-pay.svg": 25343,
	"./icons/cash.svg": 73354,
	"./icons/check-icon.svg": 22405,
	"./icons/check.svg": 87121,
	"./icons/chevron-down.svg": 1285,
	"./icons/chevrons-left.svg": 30115,
	"./icons/close-circle.png": 812,
	"./icons/close-circle.svg": 17594,
	"./icons/close-circle1.svg": 91575,
	"./icons/close-icon.svg": 13025,
	"./icons/closes.svg": 31204,
	"./icons/credit-card.svg": 26659,
	"./icons/dash1.svg": 60552,
	"./icons/dash2.svg": 76091,
	"./icons/dash3.svg": 23626,
	"./icons/dash4.svg": 36373,
	"./icons/dash5.svg": 14740,
	"./icons/dash6.svg": 62951,
	"./icons/dash7.svg": 16086,
	"./icons/dashboard.svg": 8133,
	"./icons/datepicker.svg": 45157,
	"./icons/debitcard.svg": 66377,
	"./icons/delete-2.svg": 12499,
	"./icons/delete.svg": 4738,
	"./icons/delete1.svg": 59183,
	"./icons/delete7.svg": 28833,
	"./icons/dollar-square.svg": 8827,
	"./icons/dollar.svg": 25769,
	"./icons/download.svg": 23799,
	"./icons/drag-drop.svg": 31641,
	"./icons/dropdown.svg": 43556,
	"./icons/edit-2.svg": 47930,
	"./icons/edit-5.svg": 59557,
	"./icons/edit-6.svg": 60422,
	"./icons/edit-set.svg": 16120,
	"./icons/edit.svg": 96415,
	"./icons/ellipise.svg": 73312,
	"./icons/ellipise1.svg": 4097,
	"./icons/emoj-icon-01.svg": 27148,
	"./icons/emoj-icon-02.svg": 82495,
	"./icons/emoj-icon-03.svg": 77742,
	"./icons/emoj-icon-04.svg": 3089,
	"./icons/emoj-icon-05.svg": 40288,
	"./icons/emoji-smile.svg": 11824,
	"./icons/envelope.svg": 30643,
	"./icons/excel.svg": 38860,
	"./icons/expense.svg": 24329,
	"./icons/expense1.svg": 21802,
	"./icons/eye.svg": 59850,
	"./icons/eye1.svg": 51783,
	"./icons/facebook-logo.svg": 14981,
	"./icons/facebook.png": 45089,
	"./icons/fb-icon.svg": 71987,
	"./icons/file-text-icon-01.svg": 33509,
	"./icons/filter.svg": 14401,
	"./icons/flag-01.svg": 44623,
	"./icons/flag-02.svg": 42300,
	"./icons/flag-03.svg": 70845,
	"./icons/flag-04.svg": 36914,
	"./icons/folder-minus.svg": 36828,
	"./icons/folder.svg": 34219,
	"./icons/fullscreen.svg": 24652,
	"./icons/gear.svg": 56822,
	"./icons/globe.svg": 37410,
	"./icons/google-icon.svg": 68648,
	"./icons/google.png": 46888,
	"./icons/half-circle.svg": 53421,
	"./icons/hand01.svg": 75693,
	"./icons/heart.svg": 45685,
	"./icons/hi.png": 87380,
	"./icons/hi.svg": 5586,
	"./icons/image.svg": 59682,
	"./icons/language.png": 90707,
	"./icons/life-buoy.svg": 17201,
	"./icons/like.svg": 99358,
	"./icons/linkedin-icon.svg": 19253,
	"./icons/loader.svg": 16506,
	"./icons/log-out.svg": 71364,
	"./icons/magnifier.svg": 61537,
	"./icons/mail.svg": 97686,
	"./icons/maximize.svg": 66897,
	"./icons/menu-icon-01.svg": 41256,
	"./icons/menu-icon-02.svg": 75643,
	"./icons/menu-icon-04.svg": 38485,
	"./icons/menu-icon-05.svg": 65876,
	"./icons/menu-icon-06.svg": 14087,
	"./icons/menu-icon.svg": 96028,
	"./icons/minus.svg": 30473,
	"./icons/notification-bing.svg": 85385,
	"./icons/pause.svg": 34299,
	"./icons/pause1.svg": 43152,
	"./icons/pay.svg": 59991,
	"./icons/payment-icon-01.svg": 83021,
	"./icons/payment-icon-02.svg": 51022,
	"./icons/payment-icon-03.svg": 63103,
	"./icons/payment-icon-04.svg": 13568,
	"./icons/payment-icon-05.svg": 33169,
	"./icons/payment-icon-06.svg": 12802,
	"./icons/payment-icon-07.svg": 34323,
	"./icons/payment-icon-08.svg": 22628,
	"./icons/payment-icon-09.svg": 73797,
	"./icons/payment-icon-10.svg": 83727,
	"./icons/payment-icon-11.svg": 4798,
	"./icons/payment-icon-12.svg": 33245,
	"./icons/payment-icon-13.svg": 4700,
	"./icons/payment-icon-14.svg": 32355,
	"./icons/payment-icon-15.svg": 82962,
	"./icons/payment-status.svg": 9462,
	"./icons/pdf-02.svg": 99150,
	"./icons/pdf.svg": 17603,
	"./icons/places.svg": 80131,
	"./icons/play-01.svg": 90747,
	"./icons/plus-circle.svg": 1848,
	"./icons/plus.svg": 30939,
	"./icons/plus1.svg": 1488,
	"./icons/plus11.svg": 95025,
	"./icons/plus12.svg": 40482,
	"./icons/power.svg": 95118,
	"./icons/printer.svg": 29001,
	"./icons/product.svg": 63520,
	"./icons/pur-invoice.svg": 94306,
	"./icons/purchase.svg": 29946,
	"./icons/purchase1.svg": 85815,
	"./icons/purchased-earnings.svg": 46710,
	"./icons/qr-scan.svg": 97132,
	"./icons/qrcode-scan.svg": 10213,
	"./icons/quotation1.svg": 80680,
	"./icons/razorpay.svg": 73369,
	"./icons/return1.svg": 77802,
	"./icons/reverse.svg": 89811,
	"./icons/right-arrow.svg": 20839,
	"./icons/sale.svg": 49638,
	"./icons/sales.svg": 62329,
	"./icons/sales1.svg": 31418,
	"./icons/salesinvoice.svg": 65998,
	"./icons/scan.svg": 22076,
	"./icons/scanner.svg": 94075,
	"./icons/scanner1.svg": 43984,
	"./icons/scanners.svg": 50194,
	"./icons/search-white.svg": 10407,
	"./icons/search-whites.svg": 28758,
	"./icons/search.svg": 63463,
	"./icons/settings.svg": 9468,
	"./icons/sidebar-delete-icon.svg": 84459,
	"./icons/sidebar-icon-01.svg": 95171,
	"./icons/sidebar-icon-02.svg": 38128,
	"./icons/sidebar-icon-03.svg": 73665,
	"./icons/siderbar-icon1.svg": 98752,
	"./icons/siderbar-icon2.svg": 59763,
	"./icons/siderbar-icon3.svg": 56034,
	"./icons/smile-chat.svg": 18220,
	"./icons/sms-icon-01.svg": 89416,
	"./icons/sms-icon-02.svg": 70779,
	"./icons/sms-icon-03.svg": 28810,
	"./icons/storage-icon-01.svg": 74908,
	"./icons/storage-icon-02.svg": 53935,
	"./icons/stripe.svg": 16520,
	"./icons/sun-icon.svg": 92131,
	"./icons/time-big.svg": 18661,
	"./icons/time.svg": 65832,
	"./icons/total-sales.svg": 92359,
	"./icons/transcation.svg": 37809,
	"./icons/transfer1.svg": 99363,
	"./icons/trash-bin.svg": 31495,
	"./icons/trash.svg": 82571,
	"./icons/trash12.svg": 42226,
	"./icons/twitter-icon.svg": 47746,
	"./icons/upload.svg": 38264,
	"./icons/user-icon.svg": 42404,
	"./icons/user.svg": 96602,
	"./icons/users.svg": 18917,
	"./icons/users1.svg": 73518,
	"./icons/video.svg": 57123,
	"./icons/voice.svg": 15903,
	"./icons/wallet.svg": 48304,
	"./icons/wallet1.svg": 28337,
	"./icons/weekly-earning.svg": 89835,
	"./icons/xls.svg": 20958,
	"./icons/zip.svg": 52776,
	"./img-01.jpg": 26171,
	"./img-02.jpg": 49196,
	"./img-03.jpg": 20809,
	"./img-04.jpg": 84346,
	"./img-05.jpg": 55511,
	"./img-1.jpg": 10569,
	"./img-2.jpg": 36862,
	"./img-3.jpg": 91643,
	"./img-4.jpg": 68968,
	"./img-5.jpg": 31333,
	"./join-call.jpg": 12199,
	"./join-call1.jpg": 41962,
	"./layout-01.png": 56464,
	"./layout-02.png": 26315,
	"./layout-03.png": 5186,
	"./layout-04.png": 1533,
	"./layout-ltr.png": 80983,
	"./layout-rtl.png": 59599,
	"./life-buoy.svg": 55042,
	"./login-bg.png": 68305,
	"./login-logo.png": 45805,
	"./login-user.png": 61173,
	"./login.jpg": 65885,
	"./login02.png": 5199,
	"./logo-small.png": 15607,
	"./logo-white.png": 58409,
	"./logo.png": 65549,
	"./media-link-01.jpg": 35029,
	"./media-link-02.jpg": 84042,
	"./media/media-01.jpg": 83471,
	"./media/media-02.jpg": 69856,
	"./media/media-03.jpg": 20989,
	"./media/media-04.jpg": 66230,
	"./media/media-05.jpg": 36339,
	"./media/media-35.jpg": 77118,
	"./media/media-36.jpg": 50825,
	"./media/media-6.jpg": 51614,
	"./media/media-link-01.jpg": 52512,
	"./media/media-link-02.jpg": 42831,
	"./nedam_icon2.svg": 20527,
	"./new-icons/fb-icon.svg": 48558,
	"./new-icons/flag-01.svg": 15482,
	"./new-icons/flag-02.svg": 30569,
	"./new-icons/flag-03.svg": 79352,
	"./new-icons/flag-04.svg": 99159,
	"./new-icons/google-icon.svg": 62453,
	"./new-icons/linkedin-icon.svg": 99876,
	"./new-icons/pay.svg": 31766,
	"./new-icons/payment-icon-01.svg": 42028,
	"./new-icons/payment-icon-02.svg": 21055,
	"./new-icons/payment-icon-03.svg": 83118,
	"./new-icons/payment-icon-04.svg": 48593,
	"./new-icons/payment-icon-05.svg": 8032,
	"./new-icons/payment-icon-06.svg": 98771,
	"./new-icons/payment-icon-07.svg": 84546,
	"./new-icons/payment-icon-08.svg": 86661,
	"./new-icons/payment-icon-09.svg": 8644,
	"./new-icons/payment-icon-10.svg": 12818,
	"./new-icons/payment-icon-11.svg": 45859,
	"./new-icons/payment-icon-12.svg": 79760,
	"./new-icons/payment-icon-13.svg": 78209,
	"./new-icons/payment-icon-14.svg": 18302,
	"./new-icons/payment-icon-15.svg": 97231,
	"./new-icons/razorpay.svg": 77466,
	"./new-icons/sms-icon-01.svg": 45225,
	"./new-icons/sms-icon-02.svg": 19642,
	"./new-icons/sms-icon-03.svg": 24907,
	"./new-icons/storage-icon-01.svg": 19957,
	"./new-icons/storage-icon-02.svg": 62358,
	"./new-icons/stripe.svg": 81543,
	"./new-icons/twitter-icon.svg": 86621,
	"./notes-profile/close-circle.png": 58539,
	"./notes-profile/people-profile.png": 15587,
	"./notes-profile/profile-01.png": 14395,
	"./notes-profile/profile-02.png": 52416,
	"./notes-profile/profile-03.png": 30537,
	"./people-customer/people-customer-07.jpg": 36782,
	"./people/supplier-01.png": 89720,
	"./people/supplier-02.png": 35475,
	"./people/supplier-03.png": 96618,
	"./people/supplier-04.png": 63493,
	"./people/supplier-05.png": 80604,
	"./people/supplier-06.png": 38711,
	"./people/supplier-07.png": 9486,
	"./people/supplier-08.png": 25049,
	"./people/supplier-09.png": 18800,
	"./people/supplier-10.png": 17158,
	"./phone-add-1.png": 27914,
	"./phone-add-2.png": 76897,
	"./print-receipt.png": 79664,
	"./product/Macbook.png": 77536,
	"./product/noimage.png": 95194,
	"./product/product1.jpg": 98598,
	"./product/product10.jpg": 6076,
	"./product/product11.jpg": 10777,
	"./product/product12.jpg": 20014,
	"./product/product13.jpg": 98059,
	"./product/product15.jpg": 66133,
	"./product/product17.jpg": 12071,
	"./product/product19.jpg": 27345,
	"./product/product2.jpg": 56369,
	"./product/product20.jpg": 15757,
	"./product/product21.jpg": 72304,
	"./product/product22.jpg": 87263,
	"./product/product23.jpg": 67266,
	"./product/product24.jpg": 80177,
	"./product/product28.jpg": 11637,
	"./product/product29.jpg": 4376,
	"./product/product3.jpg": 58996,
	"./product/product30.jpg": 16758,
	"./product/product31.jpg": 86867,
	"./product/product32.jpg": 9060,
	"./product/product33.jpg": 87105,
	"./product/product34.jpg": 61618,
	"./product/product35.jpg": 33999,
	"./product/product36.jpg": 20384,
	"./product/product37.jpg": 71517,
	"./product/product4.jpg": 79807,
	"./product/product44.jpg": 96531,
	"./product/product45.jpg": 26422,
	"./product/product46.jpg": 96769,
	"./product/product47.jpg": 18724,
	"./product/product48.jpg": 93143,
	"./product/product48.png": 13031,
	"./product/product49.jpg": 29306,
	"./product/product5.jpg": 67138,
	"./product/product50.jpg": 79888,
	"./product/product51.jpg": 24781,
	"./product/product52.jpg": 55554,
	"./product/product53.jpg": 47263,
	"./product/product54.jpg": 68980,
	"./product/product55.jpg": 40785,
	"./product/product56.jpg": 8582,
	"./product/product57.jpg": 98691,
	"./product/product58.jpg": 18699,
	"./product/product59.jpg": 45397,
	"./product/product6.jpg": 96397,
	"./product/product60.jpg": 44321,
	"./product/product61.png": 93120,
	"./product/product62.png": 90683,
	"./product/product63.png": 69138,
	"./product/product64.png": 99117,
	"./product/product65.png": 35876,
	"./product/product66.png": 21151,
	"./product/product67.png": 67350,
	"./product/product68.png": 6129,
	"./product/product69.jpg": 5644,
	"./product/product7.jpg": 95472,
	"./product/product8.jpg": 77227,
	"./product/product9.jpg": 81390,
	"./products/product1.jpg": 55727,
	"./profiles/avatar-01.jpg": 54802,
	"./purchased-earnings.svg": 68579,
	"./qr-code.png": 52887,
	"./register02.png": 74809,
	"./reset02.png": 24761,
	"./sending-img.png": 13322,
	"./space-upgrade.jpg": 87607,
	"./step-two.png": 82399,
	"./store/store-01.png": 47347,
	"./store/store-02.png": 35384,
	"./store/store-03.png": 56513,
	"./store/store-04.png": 58030,
	"./supplier/edit-supplier.jpg": 43632,
	"./supplier/supplier-01.png": 42277,
	"./supplier/supplier-02.png": 39854,
	"./supplier/supplier-03.png": 13495,
	"./supplier/supplier-04.png": 33880,
	"./supplier/supplier-05.png": 6593,
	"./supplier/supplier-06.png": 57610,
	"./supplier/supplier-07.png": 8371,
	"./supplier/supplier-08.png": 13076,
	"./supplier/supplier-09.png": 34205,
	"./supplier/supplier-10.png": 78471,
	"./supplier/supplier1.png": 98552,
	"./supplier/supplier10.png": 69002,
	"./supplier/supplier2.png": 94163,
	"./supplier/supplier3.png": 78602,
	"./supplier/supplier4.png": 49029,
	"./supplier/supplier5.png": 96764,
	"./supplier/supplier6.png": 20695,
	"./supplier/supplier7.png": 21198,
	"./supplier/supplier8.png": 10585,
	"./supplier/supplier9.png": 4336,
	"./theme-img-01.jpg": 24763,
	"./theme-img-02.jpg": 98316,
	"./theme-img-03.jpg": 36361,
	"./theme/layout-01.png": 54170,
	"./theme/layout-02.png": 62481,
	"./theme/layout-03.png": 22536,
	"./theme/layout-04.png": 14055,
	"./theme/layout-ltr.png": 17817,
	"./theme/layout-rtl.png": 96017,
	"./theme/theme-img-01.jpg": 12017,
	"./theme/theme-img-02.jpg": 54246,
	"./theme/theme-img-03.jpg": 35299,
	"./theme/theme-img-04.jpg": 4144,
	"./theme/theme-img-05.jpg": 47597,
	"./theme/theme-img-06.jpg": 99106,
	"./theme/theme-img-07.jpg": 35455,
	"./theme/theme-img-08.jpg": 91356,
	"./theme/theme-img-09.jpg": 5081,
	"./theme/theme-img-10.jpg": 25235,
	"./time.svg": 31569,
	"./total-sales.svg": 96795,
	"./under-maintenance.png": 5886,
	"./user-5.jpg": 78987,
	"./user-6.jpg": 94332,
	"./user-7.jpg": 81209,
	"./user-icon.svg": 70195,
	"./users/edit-user.jpg": 51535,
	"./users/user-01.jpg": 3380,
	"./users/user-02.jpg": 33091,
	"./users/user-03.jpg": 89958,
	"./users/user-04.jpg": 9037,
	"./users/user-05.jpg": 56816,
	"./users/user-06.jpg": 54815,
	"./users/user-07.jpg": 63106,
	"./users/user-08.jpg": 1145,
	"./users/user-09.jpg": 96444,
	"./users/user-10.jpg": 48346,
	"./users/user-11.jpg": 19511,
	"./users/user-12.jpg": 8584,
	"./users/user-13.jpg": 36197,
	"./users/user-14.jpg": 88862,
	"./users/user-15.jpg": 90171,
	"./users/user-16.jpg": 13196,
	"./users/user-17.jpg": 68457,
	"./users/user-18.jpg": 97650,
	"./users/user-19.jpg": 74031,
	"./users/user-20.jpg": 73855,
	"./users/user-21.jpg": 61186,
	"./users/user-22.jpg": 90445,
	"./users/user-23.jpg": 89520,
	"./users/user-24.jpg": 31171,
	"./users/user-25.jpg": 92646,
	"./users/user-26.jpg": 50417,
	"./users/user-27.jpg": 53044,
	"./users/user-28.jpg": 519,
	"./users/user-29.jpg": 88362,
	"./users/user-30.jpg": 83680,
	"./users/user-31.jpg": 22909,
	"./users/user-5.jpg": 98212,
	"./users/user-6.jpg": 40787,
	"./users/user-7.jpg": 96022,
	"./verify-img.png": 56597,
	"./voice.svg": 92420,
	"./weekly-earning.svg": 35130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;